import { render, staticRenderFns } from "./date-panel-label.vue?vue&type=template&id=36985935&scoped=true&"
import script from "./date-panel-label.vue?vue&type=script&lang=js&"
export * from "./date-panel-label.vue?vue&type=script&lang=js&"
import style0 from "./date-panel-label.vue?vue&type=style&index=0&id=36985935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36985935",
  null
  
)

export default component.exports